import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = 'https://api.artwithsaloni.com';
console.log(BACKEND_URL);
// const BACKEND_URL = /^https?:\/\//i.test(RAW_BACKEND_URL)
//   ? RAW_BACKEND_URL
//   : `https://${RAW_BACKEND_URL}`;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  function getCookie(name) {
    let cookieValue = null;
  
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
  
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
  
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
  
    return cookieValue;
  }

  const csrftoken = getCookie('csrftoken');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(
        `${API}/admin/login/`,
        new URLSearchParams({
          username: formData.username,
          password: formData.password
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          },
          withCredentials: true
        }
      );
      
      localStorage.setItem('admin_token', response.data.access_token);
      console.log(response.data.access_token);
      console.log("API URL:", `${API}/admin/login/`);
      navigate('/admin/dashboard');
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--color-gray-100)'
    }}>
      <div style={{
        backgroundColor: 'var(--color-white)',
        padding: 'var(--spacing-2xl)',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h1 className="section-title" style={{ marginBottom: 'var(--spacing-md)', textAlign: 'center' }}>
          Admin Login
        </h1>
        <p className="body-text" style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)', color: 'var(--color-gray-600)' }}>
          Sign in to manage your art portfolio
        </p>

        {error && (
          <div style={{
            padding: 'var(--spacing-md)',
            backgroundColor: '#fee',
            color: '#c00',
            borderRadius: '4px',
            marginBottom: 'var(--spacing-md)',
            border: '1px solid #fcc'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 'var(--spacing-md)' }}>
            <label htmlFor="username" className="body-text" style={{ display: 'block', marginBottom: 'var(--spacing-xs)', fontWeight: '600' }}>
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'var(--spacing-sm)',
                border: '2px solid var(--color-gray-300)',
                borderRadius: '4px',
                fontSize: '1rem',
                fontFamily: 'Inter, sans-serif'
              }}
            />
          </div>

          <div style={{ marginBottom: 'var(--spacing-lg)' }}>
            <label htmlFor="password" className="body-text" style={{ display: 'block', marginBottom: 'var(--spacing-xs)', fontWeight: '600' }}>
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'var(--spacing-sm)',
                border: '2px solid var(--color-gray-300)',
                borderRadius: '4px',
                fontSize: '1rem',
                fontFamily: 'Inter, sans-serif'
              }}
            />
          </div>

          <button 
            type="submit" 
            className="btn-primary" 
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
